export default "__VITE_ASSET__DONpjfE___"